/**
 * Courses API Module
 *
 * API calls for course management
 */

import { apiClient } from './client'
import type { CourseDto, CoursesQueryParams } from '@/types/api.types'

export const coursesApi = {
  /**
   * Get all courses for current user
   */
  async getAll(params?: CoursesQueryParams): Promise<CourseDto[]> {
    const response = await apiClient.get<CourseDto[]>('/Courses', { params })
    return response.data
  },

  /**
   * Get single course by ID
   */
  async getById(id: number): Promise<CourseDto> {
    const response = await apiClient.get<CourseDto>(`/Courses/${id}`)
    return response.data
  },
}
